import { AVATOR_LIST } from "./constants";


export const formatTimeAgo = (timestamp) => {
    const now = new Date().getTime();
    const diff = now - timestamp;

    if (diff <= 10000) { // Within 10 seconds
        return "Just now";
    }

    const yearDiff = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
    if (yearDiff > 0) {
        return `${yearDiff} year${yearDiff > 1 ? "s" : ""} ago`;
    }

    const monthDiff = Math.floor(diff / (1000 * 60 * 60 * 24 * 30));
    if (monthDiff > 0) {
        return `${monthDiff} month${monthDiff > 1 ? "s" : ""} ago`;
    }

    const dayDiff = Math.floor(diff / (1000 * 60 * 60 * 24));
    if (dayDiff > 0) {
        return `${dayDiff} day${dayDiff > 1 ? "s" : ""} ago`;
    }

    const weekDiff = Math.floor(diff / (1000 * 60 * 60 * 24 * 7));
    if (weekDiff > 0) {
        return `${weekDiff} week${weekDiff > 1 ? "s" : ""} ago`;
    }

    const hourDiff = Math.floor(diff / (1000 * 60 * 60));
    if (hourDiff > 0) {
        return `${hourDiff} hour${hourDiff > 1 ? "s" : ""} ago`;
    }

    const minuteDiff = Math.floor(diff / (1000 * 60));
    if (minuteDiff > 0) {
        return `${minuteDiff} minute${minuteDiff > 1 ? "s" : ""} ago`;
    }

    const secondDiff = Math.floor(diff / 1000);
    return `${secondDiff} second${secondDiff > 1 ? "s" : ""} ago`;
}


export const transformFun = (array) => array?.filter(l => l.subject !== "tool" && !(l.subject === "assistant" && l.content === "") && !l.hidden)?.map?.(item => ({
    ...item,
    position: item?.subject === "assistant" ? "left" : "right",
    type: item?.attachedFiles === "" ? "text" : "file",
    text: item.content,
    date: item.timestamp,
    hasInteractiveUI: !!item?.hasInteractiveUI,
    uiElements: (() => {
        try {
            // if it's a string, parse; if it's already an object, just return it
            return typeof item?.uiElements === 'string'
                ? JSON.parse(item.uiElements)
                : item?.uiElements;
        } catch {
            // malformed JSON → quietly fall back to undefined
            return undefined;
        }
    })(),
}))


export const avatarFormat = (value) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(Number(value))) {
        return value
    }
    return AVATOR_LIST[Number(value ?? 1)]
}

export const checkEmail = (text) => {
    const reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    if (reg.test(text)) {
        return true
    }
    return false
}

export const checkPhone = (text) => {
    // const reg = /^\+?[1-9]\d{1,14}$/
    const reg = /^(1[ -]?)?(\(\d{3}\)|\d{3})[ -]?\d{3}[ -]?\d{4}$/
    if (reg.test(text)) {
        return true
    }
    return false
}